(function () {
  'use strict';
  angular.module('vcpatdocs')
    .component('aideconfig', {
      restrict: 'E',
      bindings: {
      },
      templateUrl: 'vcpatdocs/aideconfig-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Config', 'Rlog', '$timeout',
        function ($log, Config, Rlog, $timeout) {
          let vm = this;


          vm.options = {updateOn: 'default blur', debounce: {default: 20000, blur: 0}};
          vm.saveConfig = saveConfig;
          vm.loadValues = loadValues;
          vm.addGroup = addGroup;
          vm.removeGroup = removeGroup;
          vm.saveConfig = saveConfig;

          vm.$onInit = function () {
            //  get aides and groups from config
            Config.$find('aideconfiguration').$then(aideconfig => {
              if (!aideconfig.hasOwnProperty('_id')) {
                aideconfig._id = 'aideconfiguration';
              }
              if (!aideconfig.hasOwnProperty('groups')) {
                aideconfig.groups = [];
              }
              if (!aideconfig.hasOwnProperty('values')) {
                aideconfig.values = [];
              }
              vm.aideconfig = aideconfig;
            }, error => {
              $log.error('Loading of aideconfiguration failed');
              Rlog.error('patdocs', 'aideconfig', 'aideconfiguration.$find() failed', {id: 'aideconfiguration'});
            })
          }; // $onInit()


          function addGroup() {
            // vm.aideconfig.groups.push({name: vm.newgroup, values: []});
            vm.aideconfig.groups.splice(0, 0, {name: vm.newgroup, values: []});
            vm.newgroup = '';
            vm.saveConfig();
          }

          function removeGroup(index) {
            vm.aideconfig.groups.splice(index, 1);
            vm.saveConfig();
          }

          function saveConfig() {
            let changedgroups = [];

            vm.aideconfig.values = uniq(vm.aideconfig.values);
            for (let i = 0; i < vm.aideconfig.groups.length; i++){
              changedgroups.push({
                name: vm.aideconfig.groups[i].name,
                values: uniq(vm.aideconfig.groups[i].values)
              });
            }
            vm.aideconfig.groups = changedgroups;
            vm.aideconfig.$save();
          }

          function uniq(a) {
            return a.sort().filter(function (item, pos, ary) {
              return !pos || item !== ary[pos - 1];
            });
          }

          // load and filter autocomplete values
          function loadValues($query) {
            let promise = new Promise(function (resolve, reject) {
              resolve(vm.aideconfig.values);
            });
            return promise.then(function (values) {
              $log.debug('promise values: ', values);
              let filteredValues = values.filter(function (value) {
                return value.name.toLowerCase().indexOf($query.toLowerCase()) !== -1;
              });
              console.log('filtered values: ', filteredValues);
              return filteredValues;
            });
          }


        }
      ] // controller
    }); // component

// klammerfriedhof
}());